import React, { Component } from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { isEmpty, find } from 'lodash';
import AssignSeat from './AssignSeat';
import EquatingSeat from './EquatingSeat';
import { str2ClassName } from 'shared/helpers';
import { StudentDetailsModal } from 'shared/components';

import './SeatingChartSeat.scss';

import UserIcon from 'assets/svgs/userSC.svg';
import CloseIcon from 'assets/svgs/close1.svg';
import AccomodationIcon from 'assets/svgs/accomodationIconBlack.svg';
import OnlineIcon from 'assets/svgs/onlineIconBlack.svg';
import StandByIcon from 'assets/svgs/standbyIconBlack.svg';
import LeftHandedIcon from 'assets/svgs/leftHandedIconBlack.svg';
import DeassignIcon from 'assets/svgs/deassign.svg';

const getCellStyle = (isDraggingOver) => ({
  background: isDraggingOver ? '#BBBBBB' : 'inherit',
});

class SeatingChartSeat extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      selectedExaminee: {},
    };

    this.showExamineeDetails = this.showExamineeDetails.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  showExamineeDetails(examinee) {
    this.setState({
      modalIsOpen: true,
      selectedExaminee: examinee,
    });
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
    });
  }

  render() {
    const {
      type,
      data,
      handleClick,
      roomTypeMaterialTypes,
      index,
      col,
      row,
      handleDeassignStudent,
      handleBlur,
      hasNowManagedFlag,
    } = this.props;

    switch (type) {
      case 'used-seats':
        return (
          <Droppable droppableId={`${row}-${col}`} data={data}>
            {(provided, snapshot) => (
              <div
                style={getCellStyle(snapshot.isDraggingOver)}
                ref={provided.innerRef}
                className="cell">
                {data ? (
                  <Draggable key={index} draggableId={`${row}-${col}`} index={index}>
                    {(provided) => (
                      <UsedSeat
                        handleClick={handleClick}
                        data={data}
                        roomTypeMaterialTypes={roomTypeMaterialTypes}
                        provided={provided}
                        handleDeassignStudent={handleDeassignStudent}
                        index={`${row}-${col}`}
                        showExamineeDetails={this.showExamineeDetails}
                        closeModal={this.closeModal}
                        selectedExaminee={this.state.selectedExaminee}
                        modalIsOpen={this.state.modalIsOpen}
                        hasNowManagedFlag={hasNowManagedFlag}
                      />
                    )}
                  </Draggable>
                ) : (
                  <UnusedSeat handleClick={handleClick} provided={provided} />
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        );

      case 'material-type':
        return isEmpty(data) ? <div className="cell"></div> : <MaterailSeat {...this.props} />;

      case 'assign':
        return isEmpty(data) ? (
          <div className="cell"></div>
        ) : (
          <AssignSeat
            materialName={this.props.materialName}
            data={data}
            handleClick={handleClick}
            availableBooklets={this.props.availableBooklets}
            roomTypeMaterialTypes={roomTypeMaterialTypes}
          />
        );

      case 'equating':
        return isEmpty(data) ? (
          <div className="cell"></div>
        ) : (
          <EquatingSeat
            materialName={this.props.materialName}
            data={data}
            handleClick={handleClick}
            cellKey={this.props.cellKey}
            handleBlur={handleBlur}
          />
        );

      default:
        return <div className="cell"></div>;
    }
  }
}

SeatingChartSeat.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.shape({}),
  handleClick: PropTypes.func.isRequired,
  roomTypeMaterialTypes: PropTypes.arrayOf(PropTypes.shape({})),
  index: PropTypes.number,
  col: PropTypes.number,
  row: PropTypes.number,
  handleDeassignStudent: PropTypes.func,
  handleBlur: PropTypes.func,
  materialName: PropTypes.string,
  availableBooklets: PropTypes.arrayOf(PropTypes.shape({})),
  cellKey: PropTypes.string,
  hasNowManagedFlag: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

const getStudent = (student) => {
  let updatedStudent = student;
  if (student && student.capacityType.hasOwnProperty('onlineFlag')) {
    updatedStudent = { ...student, onlineFlag: student.capacityType.onlineFlag };
  }
  return updatedStudent;
};

export const UnusedSeat = (props) => (
  <div className="cell unused-seat" onClick={props.handleClick}></div>
);

export const UsedSeat = (props) => {
  const { t } = useTranslation();
  const student = props.data || null;
  const updatedStudent = getStudent(student);
  return (
    <div
      className="cell used-seat"
      onClick={props.handleClick}
      onDoubleClick={() => props.showExamineeDetails(student)}
      {...props.provided.draggableProps}
      {...props.provided.dragHandleProps}
      ref={props.provided.innerRef}>
      {student && (
        <React.Fragment>
          <StudentInfo student={updatedStudent} />
          <CloseIcon tabIndex="0" className="close" id={`deassign-${student.id}`} />
          <UncontrolledPopover
            placement="top"
            trigger="legacy"
            target={`deassign-${student.id}`}
            className="deassign-popover"
            hideArrow={true}>
            <PopoverBody onClick={() => props.handleDeassignStudent(props.index)}>
              <div className="deassign-btn">
                <DeassignIcon /> {t('seatingChart.deassignBtnLabel')}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </React.Fragment>
      )}
      <div className="assigned-materials-indicator">
        {props.data.regMaterials &&
          props.roomTypeMaterialTypes &&
          props.data.regMaterials.map((seatMaterial) => {
            let materialType = find(props.roomTypeMaterialTypes, {
              id: seatMaterial.materialTypeId,
            });
            return (
              materialType && (
                <i
                  key={seatMaterial.id}
                  className={`fa fa-circle color-material-type-${str2ClassName(
                    materialType.name
                  )}`}></i>
              )
            );
          })}
      </div>
      <StudentDetailsModal
        student={props.selectedExaminee}
        modalIsOpen={props.modalIsOpen}
        closeModal={props.closeModal}
        nowManagedFlag={props.hasNowManagedFlag}
      />
    </div>
  );
};

UsedSeat.propTypes = {
  handleClick: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
  roomTypeMaterialTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  provided: PropTypes.shape({}).isRequired,
  handleDeassignStudent: PropTypes.func.isRequired,
  index: PropTypes.string.isRequired,
  showExamineeDetails: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectedExaminee: PropTypes.shape({}).isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  hasNowManagedFlag: PropTypes.bool.isRequired,
};

export const MaterailSeat = (props) => {
  const { t } = useTranslation();
  const { data, material, roomTypeMaterialTypes } = props;
  const student = props.data || null;
  const updatedStudent = getStudent(student);
  const assignedMaterial = material && find(data.regMaterials, { materialTypeId: material.id });

  return (
    <div className={`cell ${material ? 'material-seat' : 'student-seat'}`}>
      {material ? (
        assignedMaterial ? (
          <span className="serial-number">{assignedMaterial.serialNumber}</span>
        ) : (
          t('seatingChart.seatMaterialNotAssigned', { material: material.name })
        )
      ) : (
        student && <StudentInfo student={updatedStudent} />
      )}
      <div className="assigned-materials-indicator">
        {data.regMaterials &&
          roomTypeMaterialTypes &&
          data.regMaterials.map((seatMaterial) => {
            let materialType = find(roomTypeMaterialTypes, { id: seatMaterial.materialTypeId });
            return (
              materialType && (
                <i
                  key={seatMaterial.id}
                  className={`fa fa-circle color-material-type-${str2ClassName(
                    materialType.name
                  )} ${material && seatMaterial.materialTypeId === material.id && 'selected'}`}></i>
              )
            );
          })}
      </div>
    </div>
  );
};

MaterailSeat.propTypes = {
  data: PropTypes.shape({}).isRequired,
  material: PropTypes.shape({}),
  roomTypeMaterialTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const StudentInfo = (props) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="student-flags">
        {props.student.standbyFlag && (
          <span
            tabIndex="0"
            className="icons d-inline-block"
            data-bs-toggle="popover"
            data-bs-placement="top"
            data-bs-trigger="focus"
            data-bs-content={t('rosters.tooltipStandBy')}>
            <StandByIcon />
          </span>
        )}
        {props.student.leftHandedFlag && (
          <span
            tabIndex="0"
            className="icons d-inline-block"
            data-bs-toggle="popover"
            data-bs-placement="top"
            data-bs-trigger="focus"
            data-bs-content={t('rosters.tooltipLeftHand')}>
            <LeftHandedIcon />
          </span>
        )}
        {props.student.onlineFlag && (
          <div
            tabIndex="0"
            className="icons d-inline-block"
            data-bs-toggle="popover"
            data-bs-placement="top"
            data-bs-trigger="focus"
            data-bs-content={t('rosters.tooltipOnline')}>
            <OnlineIcon />
          </div>
        )}
        {props.student.accomRosterFlag && (
          <span
            tabIndex="0"
            className="icons d-inline-block"
            data-bs-toggle="popover"
            data-bs-placement="top"
            data-bs-trigger="focus"
            data-bs-content={t('rosters.tooltipAccomodation')}>
            <AccomodationIcon />
          </span>
        )}
      </div>

      <UserIcon className="user-icon" />

      <div className="user-info">
        <div>{props.student.lastName},</div>
        <div>{props.student.firstName}</div>
      </div>
    </React.Fragment>
  );
};

export default SeatingChartSeat;
